import { Filter, FilterCollection, QueryParams } from '@/common/models';
import ErrorHandler from '@/ErrorHandler';
import GlobalEventBus from '@/GlobalEventBus';
import GlobalEvents from '@/GlobalEvents';
import API from '@/org-app/api';
import { createDeleteAction, createGetAllAction, createPutAction } from '@/utils/ActionsUtils';
import i18n from '@/vueI18n';

import * as types from './mutation-types';

const actions = {
  getRoles: createGetAllAction(API.instance.getRoles, types.UPDATE_ROLES_LIST, 'messages.failedToGetRoles', false),
  getUserOrganizations: createGetAllAction(
    API.instance.getUserOrganizations,
    types.UPDATE_USERORGANIZATIONS_LIST,
    'messages.failedToGetUsers',
    false,
    (commit, res) => commit(types.UPDATE_USERORGANIZATIONS_TOTAL_COUNT, res.totalCount),
  ),
  getUserOrganization: createGetAllAction(
    API.instance.getUserOrganization,
    types.UPDATE_USERORGANIZATION,
    'messages.failedToGetUsers',
    false,
  ),
  updateUserOrganization: createPutAction(
    API.instance.putUserOrganization,
    types.SAVE_USERORGANIZATIONS,
    'messages.failedToSaveUser',
  ),
  deleteUserOrganization: createDeleteAction(
    API.instance.deleteUserOrganization,
    types.DELETE_USERORGANIZATION,
    'messages.failedToDeleteUser',
  ),

  async createUser({ commit }, { email, roleID, showLoader = true }) {
    if (showLoader) {
      GlobalEventBus.$emit(GlobalEvents.loading);
    }

    const newUser = await API.instance.createUser(email, roleID).catch((err) => {
      const msg = i18n.global.t('messages.failedToCreateUser');
      ErrorHandler.showError(msg, err);
      if (showLoader) {
        GlobalEventBus.$emit(GlobalEvents.loaded);
      }
      throw err;
    });

    const queryParams = QueryParams.for({
      filterCollection: new FilterCollection([new Filter('user_id', [newUser.user_id])]),
    });

    const userOrganizations = await API.instance.getUserOrganizations({ queryParams }).catch((err) => {
      const msg = i18n.global.t('messages.failedToCreateUser');
      ErrorHandler.showError(msg, err);
      if (showLoader) {
        GlobalEventBus.$emit(GlobalEvents.loaded);
      }
      throw err;
    });

    const newUserOrg = userOrganizations.items[0];
    commit(types.SAVE_USERORGANIZATIONS, newUserOrg);

    if (showLoader) {
      GlobalEventBus.$emit(GlobalEvents.loaded);
    }
    return newUserOrg;
  },

  async uploadUserProfilePicture({ commit }, { file, id, showLoader = true, cancelTokenSource }) {
    GlobalEventBus.$emit(GlobalEvents.loading);
    try {
      const data = await API.instance.uploadUserProfilePicture(file, id, cancelTokenSource);
      return data;
    } catch (err) {
      const msg = i18n.global.t('messages.failedToUploadPhoto');
      ErrorHandler.showError(msg, err);
      throw err;
    } finally {
      if (showLoader) {
        GlobalEventBus.$emit(GlobalEvents.loaded);
      }
    }
  },

  async deleteUserProfilePicture({ commit }, { id, showLoader = true, cancelTokenSource }) {
    GlobalEventBus.$emit(GlobalEvents.loading);
    try {
      const data = await API.instance.deleteUserProfilePicture(id, cancelTokenSource);
      return data;
    } catch (err) {
      const msg = i18n.global.t('messages.failedToDeletePhoto');
      ErrorHandler.showError(msg, err);
      throw err;
    } finally {
      if (showLoader) {
        GlobalEventBus.$emit(GlobalEvents.loaded);
      }
    }
  },
};

export default actions;
